import React, { useEffect, useState } from 'react';
import request from 'utils/request';
import config from 'config/Config';
import CommonPickerModal from '../CommonPickerModal';

/**
 * 银行支行弹窗
 * @param area
 * @param bankId
 * @param others
 * @constructor
 */
export default function BranchSearchModal({ area, bankId, visible, ...others }) {
  const [list, setList] = useState([]);
  useEffect(() => {
    if (visible) {
      const fetchBranchList = async () => {
        if (!area) {
          setList([]);
          return;
        }
        const [province, city] = area || [];
        const params = {
          headBankId: bankId
        };
        if (province && city) {
          params.provinceCode = province.value;
          params.cityCode = city.value;
        }
        const { data } = await request({
          url: `basic/bank/query/bankBranch`,
          host: config.HOST_MALL,
          method: 'post_json',
          data: params
        });
        if (Array.isArray(data)) {
          setList(
            data.map((_val) => ({
              label: _val.name,
              value: `${_val.id}`,
              name: _val.name,
              code: _val.code,
              provinceCode: _val.provinceCode,
              cityCode: _val.cityCode
            }))
          );
        }
      };
      fetchBranchList();
    }
  }, [visible]);
  return <CommonPickerModal visible={visible} list={list} {...others} />;
}



// WEBPACK FOOTER //
// ./src/pubBiz/BranchSearchModal/index.js